import React, { useState, useEffect, useRef, useMemo } from "react";

import { Link } from "react-router";
import { easyPayCalculate } from "../../../../utility/features/helpers/accountHelper";
import $ from "jquery";

import ServiceAgreementsNotEnrolled from "./serviceAgreementsNotEnrolled";
import ServiceAgreement from "../../payments/serviceAgreements";
import NoEasyPayService from "./noEasyPayServices";
import tempJson from "../../../../json/fallbackglobalvariables.json";
import Globals, { URLS } from "../../../../utility/constants/appConstants";
import styles from "../../../../styles/easyPaySettings.module.scss";
import AccountDetailsClient from "../../../../utility/apiClients/account/accountDetailsClient";
import { useDispatch, useSelector } from "react-redux";
import accountSummaryCss from "../../../../styles/myAccount/accountSummary.module.scss";
import Loader from "../../../loader";
import ErrorBlock from '../../../errorMessage';
import { setCustomerDetails } from "../../../../reduxStore/myAccount/getCustomerDetails";
import { formatDateMDYYYY } from "../../../../utility/utils/dateUtil";
import {invoiceAmountDue } from '../../../../utility/features/helpers/accountHelper';
import paymentStatusClient from '../../../../utility/apiClients/payments/paymentStatusClient';
import customerSummaryClient from "../../../../utility/apiClients/customer/customerSummaryClient";
import { setCustomerInfo } from "../../../../reduxStore/login/loginSlice";
import { useNavigate } from "react-router";
import missionStatusClient from "../../../../utility/apiClients/user/missionStatusClient";

function EasyPaySettings() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const labels = tempJson.acc;
  const accDetails = useSelector((state) => state.accountSummary.details);
  const [addressByCust, setAddressByCust] = useState([]);
  const [errMsg, setErrMsg] = useState("");
  const refSqftMapModal = useRef(null);
  const [lawnDetails, setLawnDetails] = useState({
    address: "",
    lawnAreas: [],
    totalAreaSqftValue: -1,
  });
  const [isLoading, setIsLoading] = useState(
    true
  );
  const allCustomersApiCalled = useSelector((state) => state.login.allCustomersApiCalled);

  const [
    easyPayEnrolledServiceAgreements,
    setEasyPayEnrolledServiceAgreements,
  ] = useState([]);

  const [allInvoices, setAllInvoices] = useState([]);

  const [invoiceStatuses, setInvoiceStatuses] = useState({
      processing: [],
      failed: [],
      success: [],
      not_found: [],
      onqueue: [],
      pending:[]
  });

  const customerSummaryInfo = useSelector((state) => state.login.customerInfo);
  const [customerSummary, setCustomerSummary] = useState(customerSummaryInfo);
  const selectedServiceAddress = useSelector((state) => state.accountSummary.selectedServiceAddress);
  
  const custNumbers = JSON.parse(localStorage.getItem("customerNumbers")) || [];
    
  const [serviceAddress, customerNumber] = useMemo(() => {
    let custNumber = "";
    let serviceAddr = "";
    if (selectedServiceAddress !== null) {
      [serviceAddr, custNumber] = selectedServiceAddress.split(" | ");
    } else {
      custNumber = customerSummary ? customerSummary?.[0]?.CustomerNumber : custNumbers[0];
      serviceAddr = customerSummary ? customerSummary?.[0]?.ServiceAddresses?.[0]?.address
        : "";
    }
    return [serviceAddr, custNumber];
  }, [selectedServiceAddress, customerSummary]);
    

  const { customerDetails } = useSelector(
    (state) => state.getCustomerDetails || {}
  );
  const [eligibleServiceAgreement, setEligibleServiceAgreement] = useState([]);
  const [noServiceDisplay, setNoServiceDisplay] = useState(false);

  const fetchAccountDetailsCallRef = useRef(null);
  const checkPaymentStatusCallRef = useRef(null);
  const CustomerDetailsApiCallRef = useRef(customerNumber);

  const missionStatusCheck = async () => {
    try {
      const missionStatus = await missionStatusClient();
      return !["yes"].includes(String(missionStatus?.data).trim().toLowerCase());
    } catch (err) {
      console.error("Error checking mission status api:", err);
      return false;
    }
  };

  useEffect(() => {
    if(CustomerDetailsApiCallRef.current != customerNumber) {
      CustomerDetailsApiCallRef.current = customerNumber;
      setCustomerSummary(null);
    }
  }, [customerNumber]);

  useEffect(() => {
    setCustomerSummary(customerSummaryInfo);
  }, [customerSummaryInfo]);

  const getCustomerSummary = async (custNum) => {
    if (custNum === "") return;

    const isMissionAvailable = await missionStatusCheck();
    if (!isMissionAvailable) {
      setErrMsg(Globals.acc.missionDownErrorDisplay);
      setIsLoading(false);
      return;
    }

    try {
      const customerSummary = await customerSummaryClient(custNum);

      if (customerSummary?.status && customerSummary?.status === 401 ) {
          console.log("Unauthorized access - 401");
          localStorage.clear();
          navigate("/login", { replace: true });
          return;
      }
      
      if (
        customerSummary?.data === null ||
        customerSummary?.data === undefined
      ) {
        setErrMsg("Some error occurred.");
        return;
      }

      dispatch(setCustomerInfo(customerSummary?.data));
    } catch (err) {
      setErrMsg("Some error occurred.");
    }
  };
  
  const fetchAccountDetails = async (customerNumber, serviceAddress) => {
    if(fetchAccountDetailsCallRef.current) return;

    const isMissionAvailable = await missionStatusCheck();
    if (!isMissionAvailable) {
      setErrMsg(Globals.acc.missionDownErrorDisplay);
      setIsLoading(false);
      return;
    }

    fetchAccountDetailsCallRef.current = true;
    setIsLoading(true);
    const response = await AccountDetailsClient(customerNumber, serviceAddress);
    fetchAccountDetailsCallRef.current = false;
    if (response && response?.SalesAgreements && !response.errorMsg) {
      setIsLoading(false);
      let { easyPaySvcAg, nonEasyPaySvcAg } = easyPayCalculate(
        response.SalesAgreements
      );
      
      setEasyPayEnrolledServiceAgreements(easyPaySvcAg);

      let activeServiceAgreements = [];
      easyPaySvcAg.forEach(invoice => {
          // if sales agreement has bad debt, do not show invoice
          if (invoice.isBadSalesAgreement !== 'N' && invoiceAmountDue(invoice) > 0 && invoice.inactiveReason !== 'SSP' && invoice.inactiveReason !== 'NRN') return null;
          
          if(invoice?.Invoices.length > 0){
            invoice?.Invoices.forEach(inv => {
                if (inv.invoiceBalance > 0 && inv.invoiceOpen === "Y") {
                  activeServiceAgreements.push({
                      payTotalPymt: inv.invoiceBalance,
                      salesAgrNum: inv?.salesAgrNum,
                      invoiceNo: inv?.invoiceNum,
                      invoiceAmt: inv?.invoiceBalance,
                      payBunit: invoice?.asgBunit,
                      svcLineDesc: inv?.svcServiceLine,
                      dueDate: inv?.invoiceDate,
                  });
                }
            });
          }
      });

      // Remove duplicates from activeServiceAgreements based on invoiceNo
      const uniqueActiveServiceAgreements = activeServiceAgreements.filter((item, index, self) =>
          index === self.findIndex((t) => t.invoiceNo === item.invoiceNo)
      );

      setAllInvoices(uniqueActiveServiceAgreements);

      setEligibleServiceAgreement(nonEasyPaySvcAg);
      if (easyPaySvcAg.length === 0) {
        setNoServiceDisplay(true);
      }
    } else if (response?.errorStatus === 424) {
        setErrMsg("Some error occurred.");
    } else {
      setErrMsg("Some error occurred.");
      setIsLoading(false);
      setNoServiceDisplay(true);
    }
  };

  const checkPaymentStatus = async () => {
    if(checkPaymentStatusCallRef.current) return;

    const isMissionAvailable = await missionStatusCheck();
    if (!isMissionAvailable) {
      setErrMsg(Globals.acc.missionDownErrorDisplay);
      setIsLoading(false);
      return;
    }

    checkPaymentStatusCallRef.current = true;
    setIsLoading(true);
    const allPaidInvoices = allInvoices.map(sa => ({ invoiceNumber: sa.invoiceNo, saNumber: sa.salesAgrNum }));

    try {
        const response = await paymentStatusClient(allPaidInvoices);
        checkPaymentStatusCallRef.current = false;
        if (response?.error) {
          setErrMsg("Some error occurred.");
        } else if (response?.data) {
            // Process the payment status response
            const processing = [];
            const failed = [];
            const success = [];
            const not_found = [];
            const onqueue = [];
            const pending = [];
          
            response?.data.forEach(item => {
                const invoiceNumber = item.invoice_number;
                const status = item.status.toLowerCase();

                if (status === 'processing' || status === 'in-progress') {
                    processing.push(invoiceNumber);
                } else if (status === 'failed') {
                    failed.push(invoiceNumber);
                } else if (status === 'success') {
                    success.push(invoiceNumber);
                }else if (status === 'not_found') {
                    not_found.push(invoiceNumber);
                }else if (status === 'onqueue') {
                    onqueue.push(invoiceNumber);
                }else if (status === 'pending') {
                    pending.push(invoiceNumber);
                }
            });

            setInvoiceStatuses({ processing, failed, success, not_found, onqueue, pending });
            
        } else {
          setErrMsg("Some error occurred.");
        }
    } catch (err) {
        setErrMsg("Some error occurred.");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if(allInvoices.length > 0){
      (async () => await checkPaymentStatus())();
    } 
  }, [allInvoices]);

  useEffect(() => {
    if (customerSummary != null) {
      (async () => {
        if(allCustomersApiCalled)
          await fetchAccountDetails(customerNumber, serviceAddress);
      })();
    } else {
      (async () => {
        await getCustomerSummary(customerNumber);
      })();
    }

    return () => {
      setErrMsg("");
      setIsLoading(true);
    }
  }, [customerSummary, selectedServiceAddress, serviceAddress, customerNumber, allCustomersApiCalled]);

  return (
    <>
      {errMsg == "" && isLoading && <Loader />}
      {errMsg != "" && <ErrorBlock labels={labels} errMsg={errMsg} />}
      {errMsg == "" && !isLoading && (
        <div>
          <div className="container-fluid">
            {noServiceDisplay ? (
              <NoEasyPayService labels={labels} />
            ) : (
              <>
                {easyPayEnrolledServiceAgreements?.map((agreement, i) => {
                  const title =
                    agreement.svcLineDesc ||
                    agreement.saTemplateDescription ||
                    "Service";
                  const lastService = agreement.svcLastDateServiced || "—";
                  const amountDue = (
                    agreement.PrePay?.[0]?.outStandBal ?? 0
                  ).toFixed(2);
                  const lastPayment =
                    agreement.Invoices?.[0]?.invoiceAmount?.toFixed(2);
                  const methodLast4 =
                    agreement.autoChgAcctRef?.slice(-4) ?? "—";
                  const isPrePaid = amountDue === "0.00" && !lastPayment;
                  const isEasyPay = !!lastPayment || agreement.autoChgAcctRef;

                  return (
                    <ServiceAgreement serviceAgreement={agreement}  labels = {labels} paymentsCss={styles} invoiceStatuses={invoiceStatuses}/>
                  );
                })}
              </>
            )}

            {eligibleServiceAgreement.length !== 0 && (
              <>
                <div className={`row ${styles["mb-20"]}`}>
                <div className={`col-12 ${styles["gfw-3"]} ${styles["p-0"]}`}>
                  <span className={`d-block ${styles["gfs-24"]}`}  dangerouslySetInnerHTML={{
                        __html: labels.epServicesNotEnrolled,
                      }} />
                </div>
              </div>
                <ServiceAgreementsNotEnrolled
                  saNotEnrolled={eligibleServiceAgreement}
                  labels={labels}
                />
              </>
            )}
            <div className="row">
              <div className={`col-12 ${styles["text-right"]} ${styles["py-3"]}`}>
                <Link
                  className={`${styles["bg-gray-300"]} btn btn-lg ${styles["gfs-24"]} ${styles["gfw-4"]} ${styles["py-5"]} text-white ${styles["border-radius-0"]}`}
                  to={URLS?.accountSettings || "/my-account/account-settings"}
                >
                  {labels.epBtnReturn}
                </Link>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default EasyPaySettings;
